/* eslint-disable react/jsx-no-target-blank */
import * as S from './styles';
import ChevronRight from 'components/Icons/ChevronRight';
import { BaseMain } from 'components/BaseMain';
import Button from 'components/Button';
import { Heading } from 'components/Heading';
import { Loading } from 'components/Loading';
import { MainHeader } from 'components/MainHeader';
import { useContext, useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import {
  CaretDoubleUp,
  CaretTripleUp,
  CaretUp,
  Chat,
  HexagonMinus,
  LaisIcon,
  OpenIcon,
  Star,
  Tag,
  Task,
} from 'components/Icons';
import { BaseContentMain } from 'components/BaseContentMain';
import { BoxContent } from 'components/BoxContent';
import { AmountQualification } from 'components/AmountQualification';
import { DataDetails } from 'components/DataDetails';
import { Banner } from 'components/Banner';
import WarningTriangle from 'components/Icons/WarningTriangle';
// import BuyPackage from 'components/Icons/BuyPackage';
import { QualificationContext } from 'contexts/AvailableQualification';
import moment from 'moment';
import 'moment/locale/pt-br';
import { api } from 'services/api';
import { NotificationBannerContext } from 'contexts/NotificationBannerContext';
import { ClientInfoContext } from 'contexts/ClientInfoContext';
import SubHeader from 'components/SubHeader/SubHeader';
import { useCustomUtilsHistory } from 'services/react-router-custom-history';
import { InvoiceStatus } from 'components/InvoiceStatus';
import ConsumptionDetails from './Drawer/ConsumptionDetails';
import { formatCurrency } from 'pages/PlanDetails';
import DetailsKenloLeads from './Drawer/DetailsKenloLeads/DetailsKenloLeads';
import { Switch } from 'components/switch/Switch';

import { ErrorCircle } from 'styled-icons/fluentui-system-filled';
import { FeatureContext } from 'contexts/FeaturesContext';
import { ToolTip } from 'components/ToolTip';
// import { customRoundCurrency } from 'pages/KenloSignature';

export type indicatorsProps = {
  perc_mes_atual_atendimentos_convertidos: number;
  mes: number;
  ano: number;
  perc_contratos_fechados_alto_potencial_mes_atual: number;
  perc_contratos_fechados_alto_potencial_mes_anterior: number;
  perc_cliente_alto_potencial_originacao_propria_mes_atual: number;
  perc_cliente_alto_potencial_originacao_propria_mes_anterior: number;
  comissao_estimada_mes_atual_atendimentos_venda: number;
  comissao_estimada_mes_atual_atendimentos_locacao: number;
  comissao_recebida_atual_venda: number;
  comissao_recebida_atual_locacao: number;
  qtd_leads_qualificados_mes_alto: number;
  qtd_leads_qualificados_mes_medio: number;
  qtd_leads_qualificados_mes_baixo: number;
  qtd_leads_qualificados_mes_novo_cliente: number;
  tot_leads_qualificados_mes: number;
};
export type Iindicator = {
  id_imobiliaria: number;
  id_sl: number;
  media_mensal_leads_60d: number;
  perc_finalizado_6_meses: string;
  qtd_contatos_template: number;
  qtd_etiquetas_usadas: number;
  qtd_leads_qualificados_esteira_novo_cliente: number;
  qtd_leads_qualificados_esteira_potencial_alto: number;
  qtd_leads_qualificados_esteira_potencial_baixo: number;
  qtd_leads_qualificados_esteira_potencial_medio: number;
  qtd_leads_qualificados_ultima_semana: number;
  qtd_regras_transferencia: number;
  tmp_med_primeiro_atendimento: number;
  tot_leads_qualificados_esteira: number;
  _id: string;
};
export type HistoryOfQualificationProps = {
  date: string;
  value: number;
  id_qualifier_package: number;
  id_qualifier_bought: string;
  type_transaction: string;
  transaction: string;
  qualififer_package: {
    id_qualifier_pack: string;
    name: string;
    type: number;
  };
  children: React.ReactNode;
};

export type DailyQualification = {
  date?: string;
  name_broker: string;
  name_client: string;
};

export const QualifierDetails = () => {
  const [indicatorsPerPage, setIindicatorsPerPage] = useState(3);
  const [isMobile, setIsMobile] = useState(false);
  const imobUrl = process.env.REACT_APP_URL_IMOB;
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const [indicators, setIndicators] = useState<indicatorsProps[]>([]);
  const [indicator, setIndicator] = useState<Iindicator>();
  const [useExceedingLeads, setUseExceedingLeads] = useState(false);
  const history = useCustomUtilsHistory();
  const [isOpenDetails, setIsOpenDetails] = useState(false);
  const [indicatorSelected, setIndicatorSelected] = useState<any>();
  const [inforQualifier, setInforQualifier] = useState<any>();
  const [KLdata, setKLdata] = useState<any>(null);
  const [isOpenDetailsKL, setIsOpenDetailsKL] = useState(false);
  const [isLoading] = useState(true);
  const [billing, setBilling] = useState<any>()
  //eslint-disable-next-line
  const [priceExceedingLeads, setPriceExceedingLeads] = useState<any>(null);

  const { dataAgency } = useContext(FeatureContext);
  const { type, id } = useParams<{
    id: string;
    type: string;
  }>();
  const { setDataBanner, dataBanner } = useContext(NotificationBannerContext);
  const { dataClientInfo } = useContext(ClientInfoContext);

  // const idClientImob = localStorage.getItem('useImobId');
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Verificar no carregamento
    checkMobile();

    // Adicionar event listener para mudanças de largura
    window.addEventListener('resize', checkMobile);

    // Limpar event listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const showMoreIndicators = () => {
    setIindicatorsPerPage((indicatorsPerPage) => indicatorsPerPage + 3);
  };

  const { dataQualifierBalance, fetchDataQualifierBalance } =
    useContext(QualificationContext);

  useEffect(() => {
    if (dataClientInfo?.accessTokenParam && inforQualifier?.contract_balance_product) {
      fetchDataQualifierBalance(
        dataClientInfo?.accessTokenParam,
        dataClientInfo?.idTokenParams,
        inforQualifier?.contract_balance_product,
      );
    }
  }, [
    dataClientInfo?.accessTokenParam,
    fetchDataQualifierBalance,
    dataClientInfo?.idTokenParams,
    inforQualifier?.contract_balance_product,
    dataClientInfo?.id_realstate,
  ]);

  const disableButtonVerMaisIndicators = indicatorsPerPage >= indicators.length;

  function capitalize(str: any): string {
    if (typeof str === 'string') {
      return str.charAt(0).toUpperCase() + str.slice(1);
    } else {
      return '';
    }
  }

  useEffect(() => {
    const fetchDataIndicadores = async () => {
      try {
        const { data } = await api.get(`client/indicadores`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        });
        const qualificationIndicatorsData = data.data.historia;
        setIndicator(data.data);
        setIndicators(
          qualificationIndicatorsData.sort((a: any, b: any) => {
            if (b.ano === a.ano) {
              return b.mes - a.mes;
            } else {
              return b.ano - a.ano;
            }
          }),
        );
      } catch (error) {
        console.log(error);
      }
    };
    fetchDataIndicadores();
  }, [accessToken, id, idToken]);
  useEffect(() => {
    const fetchBilling = async () => {
      try {
        const { data } = await api.get('client/billings/spare/3', {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        });
        setBilling(data.data)
      } catch (error) {
        console.log(error);
      }
    };
    fetchBilling();
  }, [accessToken, idToken]);
  useEffect(() => {
    const fetchComplementaryProducts = async () => {
      try {
        const { data } = await api.get('products', {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        });
        setInforQualifier(data.data.find((el: any) => el.id === 3));
        const complements = data.data.find((item: any) => item.id === 3);
        const complement = complements?.complements?.find(
          (item: any) => item.id === 9,
        );
        setUseExceedingLeads(complement?.using || false);
      } catch (error) {
        console.log(error);
      }
    };
    fetchComplementaryProducts();
  }, [accessToken, idToken]);

  useEffect(() => {
    const fetchDataSignatures = async () => {
      try {
        const { data } = await api.get(
          `client/signatures/${inforQualifier?.id_signature}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        const kl = data.data.signature_products.find((sig: any) =>
          sig.product.sub_category?.includes('Kenlo Leads'),
        );
        if (kl) setKLdata(kl);
      } catch (error) {
        console.log(error);
      }
    };
    inforQualifier?.id_signature && fetchDataSignatures();
  }, [accessToken, idToken, inforQualifier?.id_signature]);
  const exceedingLeads = useMemo(() => {
    return dataQualifierBalance?.balance_premium && dataQualifierBalance?.balance_premium < 0
      ? dataQualifierBalance?.balance_premium * -1
      : 0
  }, [dataQualifierBalance?.balance_premium]);
  const getBodyPerformance = () => {
    switch (type) {
      case 'details':
        return (
          <>
            {indicators?.slice(0, indicatorsPerPage).map((indicator: any) => {
              return (
                <BoxContent
                  key={`${indicator.mes}-${indicator.ano}`}
                  style={{
                    display: 'flex',
                    padding: '1.6rem 2.4rem 1.6rem 2.4rem',
                    cursor: 'pointer',
                  }}
                  color="#E5E5E5"
                  onClick={async () => {
                    await setIndicatorSelected(indicator);
                    setIsOpenDetails(true);
                  }}
                >
                  <DataDetails
                    title={`${
                      indicator.mes === moment().month() + 1
                        ? 'Este mês'
                        : capitalize(
                            `${moment(`${indicator.ano}-${indicator.mes}-01`, [
                              'YYYY-M-DD',
                              'YYYY-MM-DD',
                            ]).format('MMMM')} de ${indicator.ano}`,
                          )
                    }`}
                    subtitle={`${indicator.tot_leads_qualificados_mes} leads`}
                  />
                  <S.WrapperAmountQualification>
                    <AmountQualification
                      icon={<CaretDoubleUp />}
                      text={indicator.qtd_leads_qualificados_mes_alto}
                    />
                    <AmountQualification
                      icon={<CaretUp />}
                      text={indicator.qtd_leads_qualificados_mes_medio}
                    />
                    <AmountQualification
                      icon={<HexagonMinus />}
                      text={indicator.qtd_leads_qualificados_mes_baixo}
                    />
                    <AmountQualification
                      icon={<Star />}
                      text={indicator.qtd_leads_qualificados_mes_novo_cliente}
                    />
                  </S.WrapperAmountQualification>
                  {indicator.mes === moment().month() + 1 ? (
                    <span style={{ alignContent: 'center' }}>
                      {' '}
                      <ChevronRight />{' '}
                    </span>
                  ) : (
                    <span
                      onClick={() => setIsOpenDetails(true)}
                      style={{ alignContent: 'center' }}
                    >
                      {' '}
                      <ChevronRight />{' '}
                    </span>
                  )}
                  {/* {PerformaceDetail} */}
                </BoxContent>
              );
            })}
            {disableButtonVerMaisIndicators && (
              <S.WrapperButtonVerMais>
                <Button
                  onClick={showMoreIndicators}
                  disabled={disableButtonVerMaisIndicators}
                >
                  Ver mais
                </Button>
              </S.WrapperButtonVerMais>
            )}
          </>
        );
      case 'renew':
        return (
          <>
            {indicators?.slice(0, indicatorsPerPage).map((indicator: any) => (
              <BoxContent
                key={`${indicator.mes}-${indicator.ano}`}
                style={{
                  display: 'flex',
                  padding: '1.6rem 2.4rem',
                  cursor: 'pointer',
                }}
                color="#E5E5E5"
              >
                <DataDetails
                  title={
                    indicator.mes === moment().month() + 1
                      ? 'Este mês'
                      : capitalize(
                          moment(`${indicator.ano}-${indicator.mes}-01`, [
                            'YYYY-M-DD',
                            'YYYY-MM-DD',
                          ]).format('MMMM') + ` de ${indicator.ano}`,
                        )
                  }
                  subtitle={`${indicator.tot_leads_qualificados_mes} qualificações`}
                />
                <S.WrapperAmountQualification>
                  <AmountQualification
                    icon={<CaretTripleUp />}
                    text={indicator.qtd_leads_qualificados_mes_alto}
                  />
                  <AmountQualification
                    icon={<CaretDoubleUp />}
                    text={indicator.qtd_leads_qualificados_mes_medio}
                  />
                  <AmountQualification
                    icon={<CaretUp />}
                    text={indicator.qtd_leads_qualificados_mes_baixo}
                  />
                </S.WrapperAmountQualification>
                {indicator.mes === moment().month() + 1 ? (
                  <span
                    onClick={() => setIsOpenDetails(true)}
                    style={{ alignContent: 'center' }}
                  >
                    {' '}
                    <ChevronRight />{' '}
                  </span>
                ) : (
                  <span
                    onClick={() => setIsOpenDetails(true)}
                    style={{ alignContent: 'center' }}
                  >
                    {' '}
                    <ChevronRight />{' '}
                  </span>
                )}
              </BoxContent>
            ))}
            <S.WrapperButtonVerMais>
              <Button
                onClick={showMoreIndicators}
                disabled={disableButtonVerMaisIndicators}
              >
                Ver mais
              </Button>
            </S.WrapperButtonVerMais>
          </>
        );
      default:
        break;
    }
  };

  const pluralize = (count: any, word: any, pluralWord?: any) => {
    return count > 1 ? pluralWord ?? `${word}s` : word;
  };

  const safeCount = (count: any) => count ?? 0;

  const infors = [
    {
      icon: <Tag />,
      title:
        safeCount(indicator?.qtd_etiquetas_usadas) > 0
          ? `${indicator?.qtd_etiquetas_usadas} ${pluralize(
              indicator?.qtd_etiquetas_usadas,
              'etiqueta',
            )}`
          : 'Nenhuma etiqueta',
      subTitle: `${pluralize(
        safeCount(indicator?.qtd_etiquetas_usadas),
        'utilizada',
      )}`,
    },
    {
      icon: <Chat />,
      title:
        safeCount(indicator?.qtd_contatos_template) > 0
          ? `${indicator?.qtd_contatos_template} ${pluralize(
              indicator?.qtd_contatos_template,
              'mensagem',
              'mensagens',
            )}`
          : 'Nenhuma mensagem',
      subTitle: `${pluralize(
        safeCount(indicator?.qtd_contatos_template),
        'enviada',
      )} usando modelos`,
    },
    {
      icon: <Task />,
      title:
        safeCount(indicator?.qtd_regras_transferencia) > 0
          ? `${indicator?.qtd_regras_transferencia} ${pluralize(
              indicator?.qtd_regras_transferencia,
              'regra',
            )}`
          : 'Nenhuma regra',
      subTitle: 'de transferência automática',
    },
  ];
  useEffect(() => {
    const fetchDataPrices = async () => {
      try {
        const { data } = await api.get(
          `external-products/prices/?id_product=${KLdata?.id_product}&frequency=avulso`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setPriceExceedingLeads(data.data.cost);
      } catch (error) {
        console.log(error);
      }
    };
    KLdata?.id_product && fetchDataPrices();
  }, [
    accessToken,
    idToken,
    KLdata
  ]);
  const getStatusById = (complements: any, id: number) => {
    const complement = complements?.find((item: any) => item.id === id);
    return complement?.using ? 'Ativo' : 'Inativo';
  };
  const getIconComplements: any = {
    4: <LaisIcon />,
  };
  const percentage = useMemo(() => {
    const amount = KLdata?.product?.qty_leads ?? KLdata?.amount ?? 0;
    if (dataQualifierBalance?.balance_premium === 0 || amount === 0) {
  
      return '0';
    }
    if(Number((((dataQualifierBalance?.balance_premium as number) / amount) * 100).toFixed(2)) > 100) return "100"
    return (((dataQualifierBalance?.balance_premium as number) / amount) * 100)
      .toFixed(2)
      .toString();
  }, [
    dataQualifierBalance?.balance_premium,
    KLdata?.amount,
    KLdata?.product?.qty_leads,
  ]);
  const AlterExceedingEnvelopes = async (exceedingEnvelopes: boolean) => {
    try {
      await api.patch(
        `/products`,
        {
          using: exceedingEnvelopes,
          id_internal_product: 9,
          log: {
            id_log_type: exceedingEnvelopes ? 3 : 4,
            title: exceedingEnvelopes
              ? 'Leads pós-pagos ativados para o Kenlo Leads'
              : 'Leads pós-pagos desativados para o Kenlo Leads',
          },
        },
        {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      setUseExceedingLeads(exceedingEnvelopes);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <MainHeader />
      <SubHeader
        title="Detalhes do Produto"
        onReturn={() => history.push('/ClientArea')}
      />
      {!isLoading && <Loading />}
      <BaseMain hideHeader>
        {dataBanner && (
          <S.WrapperBanner>
            <Banner
              icon={<WarningTriangle />}
              text="O boleto do novo pacote contratado já está disponível. O saldo de qualificações será atualizado assim que recebermos o pagamento."
            >
              <a
                href={dataBanner.link2via}
                target="_blank"
                onClick={() => setDataBanner(undefined)}
              >
                Ver boleto
              </a>
            </Banner>
          </S.WrapperBanner>
        )}
        <S.BodyContentWrapper>
          <S.WrapperAside>
            <S.contentAside>
              <S.TitleAside>
                <span className="title">Kenlo Leads</span>
                <InvoiceStatus
                  status={inforQualifier?.status ? 'paga' : 'cancelada'}
                  text={inforQualifier?.status ? 'Ativo' : 'Suspenso'}
                />
              </S.TitleAside>
              <S.TitleAside>
                    <S.TextAside>Saldo disponíveis</S.TextAside>
                    <S.TextAsideSpan>
                      {dataQualifierBalance?.balance_premium && dataQualifierBalance?.balance_premium > 0 ? dataQualifierBalance?.balance_premium : 0}
                      <S.TextAsideSpan fontSize="12" color="#808080">
                        /{KLdata?.product?.qty_leads ?? KLdata?.amount ?? 0}
                      </S.TextAsideSpan>
                    </S.TextAsideSpan>
                </S.TitleAside>
              {dataQualifierBalance?.balance_premium &&
              dataQualifierBalance?.balance_premium > 0 ? (
                <>
        
                  <S.ProgressBar percentage={percentage} />
                </>
              ) : (
                <>
                  <Banner
                    icon={<WarningTriangle />}
                    text={
                      !dataAgency?.defaulter ? "O saldo de leads do seu plano acabou. Leads pós-pagos serão utilizados até o mês encerrar." :
                      "Os leads do seu plano acabaram. Você não poderá utilizar leads pós-pagos até pagar a fatura atual."   
                    }
                  >
                  </Banner>
                </>
              )}
              {inforQualifier?.id_signature ? (
                <>
                  <hr
                    style={{
                      marginLeft: '-24px',
                      marginRight: '-24px',
                      marginBottom: '24px',
                    }}
                  />
                  <S.TitleAside>
                    <S.TextAside fontWeight="700">Cobrança</S.TextAside>
                  </S.TitleAside>
                  <S.Grid>
                    <div>
                      <S.TextAside fontSize="12" color="#808080">
                        Data de contratação
                      </S.TextAside>
                      <S.TextAside>
                        {dataClientInfo?.dgLeadsActivationDate
                          ? moment(
                              dataClientInfo?.dgLeadsActivationDate,
                            ).format('DD/MM/YYYY')
                          : 'Não informado'}
                      </S.TextAside>
                    </div>
                    <div>
                      <S.TextAside fontSize="12" color="#808080">
                        Data de renovação
                      </S.TextAside>
                      <S.TextAside>
                        {moment()
                          .add(1, 'month')
                          .startOf('month')
                          .format('D[º] [de] MMMM')}
                      </S.TextAside>
                    </div>
                  </S.Grid>
                  <div>
                    <S.TextAside fontSize="12" color="#808080">
                      Valor
                    </S.TextAside>
                    <S.TextAside fontSize="20">
                      {formatCurrency(inforQualifier?.installmentValue || 0) ||
                        '0,00'}{' '}
                      /
                      {inforQualifier?.planFrequency
                        ? inforQualifier?.planFrequency === 'mensal'
                          ? 'mês'
                          : 'ano'
                        : 'não informado'}
                    </S.TextAside>
                  </div>
                </>
              ) : (
                <></>
              )}
            </S.contentAside>
            <S.contentAside style={{ marginTop: '16px' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',

                  justifyContent: 'space-between',
                }}
              >
                <S.TextAside fontWeight="700" fontSize="20">
                  Leads pós-pagos
                </S.TextAside>
                {dataAgency?.defaulter ?        <ToolTip
                  right="2rem"
                  height="3rem"
                  content={
                    "Pague a fatura atual para alterar as definições de leads pós-pagos."
                  }
                  icon={
                    <Switch
                    checked={useExceedingLeads}
                    disabled={dataAgency?.defaulter}
                    onChange={() => {
                      AlterExceedingEnvelopes(!useExceedingLeads);
                    }}
                  />
                  }
          
                /> : <Switch
                  checked={useExceedingLeads}
                  disabled={dataAgency?.defaulter}
                  onChange={() => {
                    AlterExceedingEnvelopes(!useExceedingLeads);
                  }}
                />}
              </div>
              {!useExceedingLeads && exceedingLeads > 0 && (
                <Banner
                  style={{ marginTop: '16px' }}
                  icon={<ErrorCircle size={24} style={{ marginRight: '16px' }} />}
                  text={
                    'A fatura será fechada no fim do mês. Reative quando quiser.'
                  }
                ></Banner>
              )}

              {
                <>
                  {/* { !dataAgency?.defaulter && useExceedingLeads && exceedingLeads === 0 && (
                    <S.TextAside style={{ marginTop: '16px' }}>
                      Ao fim do saldo do plano, cada lead extra terá o valor
                      de {customRoundCurrency(priceExceedingLeads)}.
                    </S.TextAside>
                  )} */}
                  {(exceedingLeads > 0 || billing)&&
                    <>
                      <S.Grid style={{ marginTop: '16px' }}>
                        <div>
                          <S.TextAside fontSize="12" color="#808080">
                            Utilizado
                          </S.TextAside>
                          <S.TextAside>
                            {billing?.compo_billing?.[0]?.products?.[0]?.amount ?? exceedingLeads} Leads
                          </S.TextAside>
                        </div>
                        {/* <div>
                          <S.TextAside fontSize="12" color="#808080">
                            {billing ? "Data de vencimento" :  "Valor do envelope"}
                          </S.TextAside>
                          <S.TextAside>{billing ? moment(
                            billing.dueDate,
                          ).format('DD/MM/YYYY') : customRoundCurrency(priceExceedingLeads)}</S.TextAside>
                        </div> */}
                        {billing ?    <div>
                          <S.TextAside fontSize="12" color="#808080">
                            Data de vencimento
                          </S.TextAside>
                          <S.TextAside>{moment(
                            billing.dueDate,
                          ).format('DD/MM/YYYY') }</S.TextAside>
                        </div>: <></>}
                      </S.Grid>

                      {/* <div>
                        <S.TextAside fontSize="12" color="#808080">
                          Valor da fatura
                        </S.TextAside>
                        <S.TextAside>{customRoundCurrency(billing?.compo_billing?.[0]?.products?.[0]?.value ?? (exceedingLeads * priceExceedingLeads))}</S.TextAside>
                      </div> */}
                    </>
                  }

                </>
              }

            </S.contentAside>
          </S.WrapperAside>
          <S.WrapperMain>
            <S.contentAside>
              <S.TitleAside>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <CaretDoubleUp />
                  <div>
                    <S.TextAside fontSize="32" fontWeight="700">
                      {indicator?.tot_leads_qualificados_esteira || 0} leads
                    </S.TextAside>
                    <S.TextAside
                      fontSize="16"
                      color="#808080"
                      style={{ marginTop: '8px' }}
                    >
                      qualificados em atendimento
                    </S.TextAside>
                  </div>
                </div>
                {!isMobile && (
                  <S.TextAside
                    fontSize="16"
                    color="#F82E52"
                    fontWeight="700"
                    cursor
                    onClick={() =>
                      window.open(
                        `${imobUrl}/admin/default.aspx#/new-digital-rent`,
                        '_blank',
                      )
                    }
                  >
                    <OpenIcon color="#F82E52" />
                    Abrir atendimentos
                  </S.TextAside>
                )}
              </S.TitleAside>
              <hr style={{ margin: ' 0 -24px ' }} />
              <S.GridInfos>
                {infors.map((el, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                    }}
                  >
                    {el.icon}
                    <div>
                      <S.TextAside fontSize="16" fontWeight="700">
                        {el.title}
                      </S.TextAside>
                      <S.TextAside fontSize="12" color="#808080">
                        {el.subTitle}
                      </S.TextAside>
                    </div>
                  </div>
                ))}
              </S.GridInfos>
            </S.contentAside>
            {inforQualifier?.complements.some(
              (el: any) => el.status === 'ativo' && el.using === true && el.id !== 9,
            ) ? (
              <S.contentAside>
                <S.TitleAside>
                  <S.TextAside fontSize="20" fontWeight="600">
                    Integrações
                  </S.TextAside>
                  {!isMobile && (
                    <S.TextAside
                      fontSize="16"
                      color="#F82E52"
                      fontWeight="700"
                      cursor
                      onClick={() =>
                        window.open(
                          `${imobUrl}/admin/default.aspx#/kenlo-marketplace`,
                          '_blank',
                        )
                      }
                    >
                      <OpenIcon color="#F82E52" />
                      Abrir marketplace
                    </S.TextAside>
                  )}
                </S.TitleAside>
                {inforQualifier?.complements
                  .filter(
                    (el: any) => el.status === 'ativo' && el.using === true && el.id !== 9,
                  )
                  .map((el: any, index: any) => (
                    <S.TitleAside
                      key={index}
                      style={{
                        border: '1px solid #F2F2F2',
                        borderRadius: '12px',
                        padding: '16px 24px',
                        alignItems: 'center',
                        marginBottom: '0px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                        }}
                      >
                        {getIconComplements[el.id]}
                        <div>
                          <S.TextAside
                            fontSize="16"
                            fontWeight="500"
                            color="#808080"
                          >
                            {el.name}
                          </S.TextAside>
                          <S.TextAside fontSize="16" fontWeight="700">
                            {getStatusById(inforQualifier?.complements, el.id)}
                          </S.TextAside>
                        </div>
                      </div>
                    </S.TitleAside>
                  ))}
              </S.contentAside>
            ) : (
              <></>
            )}
            <BaseContentMain
              padding="2.4rem 2.4rem 2.4rem 2.4rem"
              title={
                <S.WrapperTitle>
                  <Heading
                    title="Consumo mensal"
                    weight="600"
                    size="large"
                    color="#1A1A1A"
                  />
                </S.WrapperTitle>
              }
            >
              {getBodyPerformance()}
            </BaseContentMain>
            {/*
            <BaseContentMain
              padding="2.4rem 2.4rem 2.4rem 2.4rem"
              title={
                <S.WrapperTitle>
                  <Heading
                    title="Histórico"
                    weight="600"
                    size="large"
                    color="#242424"
                  />
                </S.WrapperTitle>
              }
            >
              <S.WrapperDescription>
                <p>Data</p>
                <p>Descrição</p>
                <p>Qualificações</p>
                <p></p>
              </S.WrapperDescription>
              <Line width="100%" border="1px" />
              <S.WrapperHistoryOfQualification>
                {getBodyHistory()}
              </S.WrapperHistoryOfQualification>
            </BaseContentMain> */}
          </S.WrapperMain>
        </S.BodyContentWrapper>
      </BaseMain>
      {isOpenDetails && (
        <ConsumptionDetails
          closeDrawer={() => setIsOpenDetails(false)}
          indicator={indicatorSelected}
          idConsumption={dataClientInfo?.id_realstate}
          exceedingLeads={exceedingLeads}
        />
      )}
      {isOpenDetailsKL && (
        <DetailsKenloLeads
          closeDrawer={() => setIsOpenDetailsKL(false)}
          signature={KLdata}
          infoQualifier={inforQualifier}
          balance={dataQualifierBalance}
        />
      )}
    </>
  );
};
